import * as React from "react";
const SvgFiRrInsightAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-insight-alt_svg__a)">
      <path
        fill="#062147"
        d="M17.994 2.286A9.05 9.05 0 0 0 10.956.06C6.905.517 3.591 3.782 3.075 7.822c-.374 2.932.644 5.76 2.792 7.76C7.243 16.862 8 18.483 8 20.15v.351c0 1.93 1.57 3.5 3.5 3.5h1c1.93 0 3.5-1.57 3.5-3.5v-.185c0-1.816.704-3.476 1.933-4.552a8.997 8.997 0 0 0 .061-13.477M14 20.5c0 .827-.673 1.5-1.5 1.5h-1c-.827 0-1.5-.673-1.5-1.5l-.008-.5h4.024zm2.614-6.24c-1.105.967-1.888 2.272-2.294 3.74H9.678c-.421-1.43-1.248-2.765-2.448-3.88-1.671-1.557-2.463-3.759-2.171-6.044.4-3.137 2.975-5.673 6.121-6.029q.417-.046.828-.047c1.725 0 3.353.617 4.652 1.778a6.991 6.991 0 0 1-.046 10.481m-.282-7.756a1 1 0 0 0-1.365-.367l-.568.327a3.5 3.5 0 0 0-1.399-.8V5a1 1 0 1 0-2 0v.663a3.5 3.5 0 0 0-1.399.801l-.568-.327a.999.999 0 1 0-.998 1.733l.567.327a3.5 3.5 0 0 0-.102.804c0 .278.041.544.102.803l-.567.326a.999.999 0 0 0 .5 1.867 1 1 0 0 0 .498-.133l.569-.327c.391.37.869.642 1.398.801v.663a1 1 0 1 0 2 0v-.663a3.5 3.5 0 0 0 1.398-.8l.569.326a1 1 0 0 0 .998-1.734l-.567-.326a3.5 3.5 0 0 0 .102-.803c0-.277-.041-.544-.102-.804l.567-.327a1 1 0 0 0 .367-1.366M12 10.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-insight-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrInsightAlt;
